




import Vue from 'vue'
import Environments from "@/components/Environments.vue"

export default Vue.extend({
  name: 'Home',
  components: {
    Environments,
  },
})
